<template>
<v-container pa-5 style="background-color:#f3f3f3; padding:3px" flat>
            <v-row >
          <v-col cols="12" align="center"><h1 class="font-weight-light">Informazioni</h1></v-col>    
        </v-row >
    <v-skeleton-loader
        ref="skeleton"
        type="list-item-avatar"
        class="mx-auto"
        :loading="loading"
      >
    <v-card style="padding:10px">
        <v-list-item
        v-for="riga in allegatibacheca" 
        :key="riga.IdDocumento"
      >
        <v-list-item-avatar>
          <v-icon>mdi-file-document-outline</v-icon>
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title v-text="riga.Titolo + '  '+riga.Area"></v-list-item-title>
          <v-list-item-subtitle v-text="riga.Descrizione"></v-list-item-subtitle>
        </v-list-item-content>

        <v-list-item-action>
          <v-btn :href="riga.UrlDocumento"><v-icon>mdi-file-eye-outline</v-icon></v-btn>
        </v-list-item-action>
      </v-list-item>
        
</v-card>
</v-skeleton-loader>

    </v-container>
</template>
<script>
export default {
      props:['Area'],
       data: () => ({
           righe:[],
           currenturl:'http://www.ansa.it',
           loading:false,
           dialog:false
       }),
       computed:{
            importo_da_pagare(){
                let t =0;
                for (let index = 0; index < this.righe.length; index++) {
                    const element = this.righe[index];
                    t+= element.Totale;
                    
                }
                return t;
            },
            allegatibacheca () {
              var allegati=[];
              try {
                  this.$store.state.config2.forEach(conf => {
                    conf.ListaBacheca.forEach(element => {
                      if(conf.LINGUA.toLowerCase() == this.$store.state.currentlan.toLowerCase()){
                          if(element.Area && element.Area.toLowerCase()== 'informazioni'){
                          allegati.push(element)
                        }
                      }

                      

                   
                  });              
              });
              } catch (error) {
                  console.error(error)
              }


              return allegati;
            }
       },
    methods: {
    getdocs: function() {
      this.loading=true
      console.log("AVVIO DOCUMENTI")
      const payload = {
        Comando: "GetAllegatiPrenCO",
      };
      console.log(payload);
      const me = this;
      this.$store.dispatch("APIRequestHR", payload).then(risp => {
        console.log(risp);
        if (risp.statusText == "OK") {
          me.righe = risp.data.RISULTATOJSON.Allegati;
        }
        this.loading=false
      });
    }
  },
       mounted() {
           this.getdocs()
       },
}
</script>